// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88682730","453":"1d672efd","667":"6a997192"}[chunkId] + ".chunk.js";
};